/**
 * @generated SignedSource<<8b0dda85f008452bee8cfcf80a78794d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpNetPriceVariant_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "usePdpNetPriceVariant_user";
};
export type usePdpNetPriceVariant_user$key = {
  readonly " $data"?: usePdpNetPriceVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpNetPriceVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpNetPriceVariant_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "79dd11ae0fc0b5c3d7eb5ca008859a5a";

export default node;
